function matchingBandHandler(ringProduct) {
  console.log("Cart Button Clicked This Object:", ringProduct);
  let matchingBandSKU = ringProduct.minus.getAttribute("matching-band-sku");
  let matchingBandSize = ringProduct.minus.getAttribute("matching-band-size");
  console.log("Matching Band SKU:", matchingBandSKU);
  console.log("Matching Band Size:", matchingBandSize);

  // Fetch the cart contents
  fetch('/cart.js').then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }).then(cart => {
    // Use the Array.prototype.find method to filter items
    console.log("fetched cart items:", cart);
    const filteredItem = cart.items.find(item => item.properties["SKU"] === matchingBandSKU && item.properties["Size"] === matchingBandSize);
    if (filteredItem) {
      // Construct the URL for the Cart Change API
      const apiUrl = `/cart/change.js?id=${filteredItem.key}&quantity=0`;
      // Make a GET request to the Cart Change API
      return fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } else {
      // Handle the case where no matching item was found
      return {
        message: "Matching item not found in the cart."
      };
    }
  }).then(data => {
    // Handle the response data here
    console.log('Cart Change API Response:', data);
    ringProduct._change(0);
  }).catch(error => {
    console.error('Error:', error);
  });
}
function matchingRingHandler(bandProduct) {
  console.log("Cart Button Clicked This Object:", bandProduct);
  let matchingRingSKU = bandProduct.minus.getAttribute("matching-ring-sku");
  let matchingRingSize = bandProduct.minus.getAttribute("matching-ring-size");
  console.log("Matching Ring SKU:", matchingRingSKU);
  console.log("Matching Ring Size:", matchingRingSize);

  // Fetch the cart contents
  fetch('/cart.js').then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }).then(cart => {
    // Use the Array.prototype.find method to filter items
    console.log("fetched cart items:", cart);
    const filteredItem = cart.items.find(item => item.properties["SKU"] === matchingRingSKU && item.properties["Ring Size"] === matchingRingSize);
    if (filteredItem) {
      delete filteredItem.properties['Matching Band SKU'];
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: filteredItem.key,
          quantity: filteredItem.quantity,
          properties: filteredItem.properties
        })
      });
    } else {
      // Handle the case where no matching item was found
      return {
        message: "Matching item not found in the cart."
      };
    }
  }).then(data => {
    // Handle the response data here
    console.log('Cart Change API Response:', data);
    bandProduct._change(0);
  }).catch(error => {
    console.error('Error:', error);
  });
}